/* Model */
class GlobalConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'GlobalConfiguration';

  save = (values, callbacks) => {
    const ajax = new Monet.Ajax();
    const model = this;

    ajax.url = 'GlobalConfiguration';
    ajax.method = 'PATCH';
    ajax.data = values;
    ajax.success = ajax.success = function (data, xhr) {
      callbacks.success(data, xhr);
      model.renderInlineMessage('geotabsyncconfiguration.saved', 'success');
    };
    ajax.error = function (xhr) {
      model.renderInlineMessage(
        'general.exception.service.unavailable',
        'success'
      );
      callbacks.error(model, xhr);
    };
    ajax.send();
  };

  renderInlineMessage = (resourceKey, type) => {
    const monetMessage = new Monet.Form.Messages.InlineMessage();
    const resourceMessage = Monet.I18n.getResourcesByKey(resourceKey);
    const errorMessages = [];
    errorMessages.push(
      Monet.Form.Messages.mountErrorMessageObject(resourceMessage)
    );

    monetMessage.setScope(`#GlobalConfiguration .GlobalConfiguration`);
    monetMessage.setInfoType(type);
    monetMessage.setMessage({ errorMessages });
    monetMessage.triggerMessage();
  };
}

App.Models.GlobalConfiguration = GlobalConfigurationModel;

/* Collection */
class GlobalConfigurationCollection extends App.Collections.BaseCollection {
  url = 'GlobalConfiguration';
  model = App.Models.GlobalConfiguration;
}

App.Collections.GlobalConfigurations = GlobalConfigurationCollection;

/* Router */
class GlobalConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'GlobalConfiguration';
    const model = App.Models.GlobalConfiguration;
    const collectionClass = App.Collections.GlobalConfigurations;

    super(entityName, model, collectionClass);
  }

  renderOptionsOptimization = () => {
    const optmizationObjectivesContainer = document.querySelector(
      '#GlobalConfiguration .MonetUIFormSectionColumn .optionGroup'
    );

    const wrapper = document.createElement('div');
    wrapper.classList.add('optionsWrapper');
    optmizationObjectivesContainer.appendChild(wrapper);

    const options = document.querySelectorAll(
      '#GlobalConfiguration .MonetUIFormSectionColumn .optionGroup > .radio_group_item'
    );

    options.forEach((opt) => wrapper.appendChild(opt));

    const optionsHint = document.createElement('div');
    optionsHint.classList.add('optionsHint');
    optmizationObjectivesContainer.appendChild(optionsHint);
  };

  renderPhotoSharpnessHint = (value) => {
    const optionsHintElement = document.querySelector('.optionsHint');
    const renderHintContent = (title, description) => {
      return `<span class="hintContent">
          <b>${Monet.I18n.getResourcesByKey(
            title
          )}</b>:&nbsp;${Monet.I18n.getResourcesByKey(description)}
        </div>`;
    };
    switch (value) {
      case 'L':
        optionsHintElement.innerHTML = renderHintContent(
          'globalConfig.photoSharpnessLevel.low',
          'globalconfig.photoSharpnessLevel.low.description'
        );
        break;
      case 'M':
        optionsHintElement.innerHTML = renderHintContent(
          'globalConfig.photoSharpnessLevel.medium',
          'globalconfig.photoSharpnessLevel.medium.description'
        );
        break;
      case 'H':
        optionsHintElement.innerHTML = renderHintContent(
          'globalConfig.photoSharpnessLevel.high',
          'globalconfig.photoSharpnessLevel.high.description'
        );
        break;
      default:
        optionsHintElement.innerHTML = '';
    }
  };

  renderPhotoQualitySectionDescription = () => {
    const photoQualitySectionTitle = document.querySelector(
      '#GlobalConfiguration .MonetUIFormSection[key="pls_edit_photo_quality_global_configuration"] > .MonetUIFormSectionTitle'
    );
    const photoQualitySectionDescription = document.createElement('span');
    photoQualitySectionDescription.classList.add('photoQualitySectionDescription');
    photoQualitySectionDescription.innerHTML = Monet.I18n.getResourcesByKey(
      'globalconfiguration.photoQualitySectionDescription'
    );
    photoQualitySectionTitle.appendChild(photoQualitySectionDescription);
  }

  afterCreate = (model) => {
    Monet.Session.Configurations.size1Alias = model.size1Alias;
    Monet.Session.Configurations.size2Alias = model.size2Alias;
    Monet.Session.Configurations.size3Alias = model.size3Alias;

    window.location = '#/' + this.entityName;
  };

  beforeSave = (saveCallback) => {
    App.Forms.GlobalConfiguration.form.fields.logo.deleteFile(saveCallback);
  };

  setIcon = (iconClass, field) => {
    const icon = document.createElement('span'),
      label = field.rootEl.querySelector('label'),
      oldIcon = label.querySelector('.icon');

    icon.className = 'icon ' + iconClass;
    if (oldIcon) {
      label.removeChild(oldIcon);
    }
    label.appendChild(icon);
  };

  afterCreateForm = () => {
    const setIcon = function (gridData) {
      App.Objects.GlobalConfiguration.setIcon(gridData.icon, this);
    };
    const fields = App.Forms.GlobalConfiguration.form.fields;
    const formElement = document.querySelector(
      '.MonetUIForm.GlobalConfiguration'
    );
    const headerElement = this.createNewHeaderElement();

    fields.size1AliasConfig.addListenerToAfterSelectRow(
      setIcon.bind(fields.size1AliasConfig)
    );
    fields.size2AliasConfig.addListenerToAfterSelectRow(
      setIcon.bind(fields.size2AliasConfig)
    );
    fields.size3AliasConfig.addListenerToAfterSelectRow(
      setIcon.bind(fields.size3AliasConfig)
    );

    $('.MonetUIFormSectionButton.buttonsUp').remove();
    $('#GlobalConfiguration_btn_cancel').remove();

    formElement.children[0]?.before(headerElement);

    if (fields.enablePhotoQualityCheck && fields.photoSharpnessLevel) {
      fields.photoSharpnessLevel.show = function () {
        fields.photoSharpnessLevel.isHidden = false;
        fields.photoSharpnessLevel.rootEl.style.display = 'block';
      };

      fields.photoSharpnessLevel.getRadioButtons().forEach((radio) => {
        radio.rootEl.addEventListener('click', (event) => {
          const { target: { value } } = event;
          if (value) {
            this.renderPhotoSharpnessHint(value);
          }
          event.stopPropagation()
        });
      });

      fields.enablePhotoQualityCheck.addClickEventListener(
        ({ target: { checked } }) => {
          const { photoSharpnessLevel } = fields;

          if (checked) {
            photoSharpnessLevel.show();
          } else {
            photoSharpnessLevel.hide();
            this.renderPhotoSharpnessHint('');
          }
        }
      );
      this.renderPhotoQualitySectionDescription();
      this.renderOptionsOptimization();
    }
  };

  beforeRenderDataToForm = (model, callback) => {
    if (model.attributes.enablePhotoQualityCheck) {
      this.collection.models[0].attributes.photoSharpnessLevel = `${model.get(
        'photoSharpnessLevel'
      )}`;
    }
    callback(model);
  };

  afterPopulateForm = (model) => {
    const {
      photoSharpnessLevel,
      size1AliasConfig,
      size2AliasConfig,
      size3AliasConfig
    } = App.Forms.GlobalConfiguration.form.fields;
    App.Objects.GlobalConfiguration.setIcon(
      model.attributes.size1AliasConfig.icon,
      size1AliasConfig
    );
    App.Objects.GlobalConfiguration.setIcon(
      model.attributes.size2AliasConfig.icon,
      size2AliasConfig
    );
    App.Objects.GlobalConfiguration.setIcon(
      model.attributes.size3AliasConfig.icon,
      size3AliasConfig
    );

    if (!model.attributes.enablePhotoQualityCheck && photoSharpnessLevel) {
      photoSharpnessLevel.hide();
    }

    if (model.attributes.photoSharpnessLevel) {
      this.renderPhotoSharpnessHint(model.attributes.photoSharpnessLevel);
    }
  };

  makeListScreen = () => {
    const GLOBAL_CONFIGURATION_DEFAULT_DATA_INDEX = 1;

    App.Objects.GlobalConfiguration.edit(
      GLOBAL_CONFIGURATION_DEFAULT_DATA_INDEX
    );
  };

  createNewHeaderElement = () => {
    const gridHeaderContainer = document.createElement('div');
    const leftContainer = document.createElement('div');
    const titleContainer = document.createElement('div');
    const subtitleContainer = document.createElement('div');
    const monetUIFormSectionButton = document.createElement('div');
    const btnHelp = document.createElement('a');
    const btnSave = document.createElement('input');

    gridHeaderContainer.setAttribute('class', 'gridHeaderContainer');
    leftContainer.setAttribute('class', 'leftContainer');

    titleContainer.setAttribute('class', 'titleContainer');
    titleContainer.innerHTML = Monet.I18n.getResourcesByKey(
      'globalconfiguration.userinterface.description'
    );

    subtitleContainer.setAttribute('class', 'subtitleContainer');
    subtitleContainer.innerHTML = Monet.I18n.getResourcesByKey(
      'globalconfiguration.subtitle'
    );

    monetUIFormSectionButton.setAttribute(
      'class',
      'MonetUIFormSectionButton buttonsUp'
    );

    btnHelp.setAttribute(
      'href',
      'https://greenmile.help.descartesservices.com'
    );
    btnHelp.setAttribute('class', 'MonetUIHelpLink');
    btnHelp.setAttribute('title', 'Help');

    btnSave.setAttribute('type', 'button');
    btnSave.setAttribute('value', 'Save');
    btnSave.setAttribute('id', 'GlobalConfiguration_btn_save');
    btnSave.setAttribute('name', 'btn_save');
    btnSave.setAttribute('buttonorder', '1');
    btnSave.setAttribute('class', 'MonetUIButton btn');
    btnSave.onclick = () => App.Objects.GlobalConfiguration.update();

    gridHeaderContainer.appendChild(leftContainer);

    monetUIFormSectionButton.appendChild(btnHelp);
    monetUIFormSectionButton.appendChild(btnSave);

    gridHeaderContainer.appendChild(monetUIFormSectionButton);

    return gridHeaderContainer;
  };
}

App.Routers.GlobalConfiguration = GlobalConfigurationRouter;
